import { render, staticRenderFns } from "./MassEditAutomailSettings.vue?vue&type=template&id=40c66c7a&scoped=true"
import script from "./MassEditAutomailSettings.vue?vue&type=script&lang=ts"
export * from "./MassEditAutomailSettings.vue?vue&type=script&lang=ts"
import style0 from "./MassEditAutomailSettings.vue?vue&type=style&index=0&id=40c66c7a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c66c7a",
  null
  
)

export default component.exports